import { Injectable } from '@angular/core';
import { NurseHandOverData, nurseHandoverSetting, nurseHOMst } from '../../../interfaces/masters/nursehandover';
import { NurseHandOverApi } from '../api/nurse-handover.api';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Employee } from '../../../interfaces/masters/employee';

@Injectable({
  providedIn: 'root'
})
export class NursehandoverService extends NurseHandOverData {

  constructor(private api:NurseHandOverApi){
    super();
   }
  get(url:string,queryparams:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>{
    return this.api.get(url,queryparams)
  }

  create(url:string,data:nurseHOMst): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>{
    return this.api.add(url,data)
  }

  update(url: string, data: nurseHOMst,queryparams:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}> {
      return this.api.update(url,data,queryparams)
  }

}
